export default "__VITE_ASSET__Ccu_J53G__"